import { notification } from 'antd';
import fetcher from './fetcher';

export type UploadPayload = {
	file: File;
	fileid: string;
	filepath: string;
	onProgress?: (percentage: number) => void;
};

export const uploader = async ({
	file,
	fileid,
	filepath,
	onProgress,
}: UploadPayload) => {
	const uploadBaseUrl = import.meta.env.VITE_FLEET_UPLOAD_URL as string;
	const getPresignedUrl = async () => {
		const response = await fetch(uploadBaseUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				fileid,
				filepath,
				filename: file.name,
				filetype: file.type,
			}),
		});

		const data = await response.json();
		return data.uploadUrl as string;
	};

	const uploadUrl = await getPresignedUrl();
	const previewRes = await fetcher<{ url: string }>({
		api: '/aws/create-signed-url',
		body: {
			key: `${filepath}/${fileid}-${file.name}`,
			expired: 3600,
		},
	});

	return new Promise<string>((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		xhr.open('PUT', uploadUrl, true);
		xhr.setRequestHeader('Content-Type', file.type);

		xhr.upload.onprogress = (event) => {
			if (event.lengthComputable && onProgress) {
				const percentage = Math.round((event.loaded * 100) / event.total);
				onProgress(percentage);
			}
		};

		xhr.onload = () => {
			if (xhr.status === 200) {
				resolve(previewRes.data.url);
			} else {
				reject('File upload failed');
			}
		};

		xhr.onerror = () => {
			reject('File upload failed');
			notification.error({
				message: 'File upload failed',
				duration: 3,
			});
		};

		xhr.send(file);
	});
};
